/* ==========================================================================
   AGDEL — Logique fiche produit  (Itération 2/4)
   - changement de variante sans rechargement (prix + disponibilité rafraîchis
     depuis le rendu serveur de la section, donc toujours bien formatés)
   - ajout au panier et ajout de l'échantillon en AJAX
   ========================================================================== */
(() => {
  'use strict';

  class AgdelProduct {
    constructor(root) {
      this.root = root;
      this.sectionId = root.dataset.sectionId;
      this.form = root.querySelector('form');
      this.idInput = root.querySelector('[data-variant-id]');
      this.status = root.querySelector('[data-status]');
      this.addBtn = root.querySelector('[data-add-to-cart]');
      this.addUrl = root.dataset.cartAddUrl;
      this.cartUrl = root.dataset.cartUrl;
      this.variants = JSON.parse(root.querySelector('[data-variants]').textContent);

      this.form.addEventListener('change', (e) => { if (e.target.type === 'radio') this.onOptionChange(); });
      this.form.addEventListener('submit', (e) => { e.preventDefault(); this.add(this.idInput.value, this.addBtn); });

      const sample = root.querySelector('[data-sample-variant]');
      if (sample) sample.addEventListener('click', () => this.add(sample.dataset.sampleVariant, sample));

      this.updateOptionAvailability();
    }

    selectedOptions() {
      return [...this.root.querySelectorAll('.agdel-option')].map((fs) => {
        const checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    findVariant(options) {
      return this.variants.find((v) => v.options.every((val, i) => val === options[i]));
    }

    /* Grise les valeurs qui n'existent pas en combinaison avec le choix courant */
    updateOptionAvailability() {
      const current = this.selectedOptions();
      this.root.querySelectorAll('.agdel-option').forEach((fs, index) => {
        fs.querySelectorAll('input').forEach((input) => {
          const test = current.slice();
          test[index] = input.value;
          const v = this.findVariant(test);
          input.disabled = !v || !v.available;
        });
      });
    }

    async onOptionChange() {
      const variant = this.findVariant(this.selectedOptions());
      this.updateOptionAvailability();
      if (!variant) { this.say('Cette combinaison n\'est pas disponible.'); return; }
      this.idInput.value = variant.id;
      this.say('');

      // URL partageable de la variante
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);

      // Rafraîchit prix + bouton depuis le rendu serveur de la section
      try {
        const res = await fetch(`${url.pathname}?variant=${variant.id}&section_id=${this.sectionId}`);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');

        const price = doc.querySelector('[data-product-price]');
        const target = this.root.querySelector('[data-product-price]');
        if (price && target) target.innerHTML = price.innerHTML;

        const label = this.root.querySelector('[data-add-label]');
        const newLabel = doc.querySelector('[data-add-label]');
        if (label && newLabel) label.textContent = newLabel.textContent.trim();
        this.addBtn.disabled = !variant.available;
      } catch (err) {
        console.error('[Agdel] Mise à jour de la variante impossible', err);
      }
    }

    async add(variantId, btn) {
      if (!variantId || btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      this.say('');

      try {
        const res = await fetch(this.addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Ajout impossible');

        this.say('Ajouté au panier.');
        // Point d'accroche : le tiroir panier du thème peut écouter cet événement
        document.dispatchEvent(new CustomEvent('agdel:cart:added', { detail: data }));
        if (window.AgdelCart && typeof window.AgdelCart.open === 'function') window.AgdelCart.open();
        else if (!document.querySelector('[data-cart-drawer]')) window.location.href = this.cartUrl;
      } catch (err) {
        this.say(err.message);
      } finally {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
      }
    }

    say(message) { if (this.status) this.status.textContent = message; }
  }

  const init = (scope = document) => {
    scope.querySelectorAll('[data-product-root]:not([data-product-bound])').forEach((el) => {
      el.setAttribute('data-product-bound', '');
      new AgdelProduct(el);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
